module.exports = __webpack_public_path__ + "assets/9f1a4920ea84a279eb9fdbba6a0db6d8.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/randWilds/FirstTrigger.mp3
 ** module id = 376
 ** module chunks = 0
 **/